import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created with ♥ by <b><a href="https://luminaapps.co" target="_blank">Lumina Apps</a></b>
    </span>
    <div class="socials">
      <a href="https://www.linkedin.com/company/31027814/" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
